import React from "react";
import "./header.css";
import { getStaticUrl } from "../../../utils/getStaticUrl";

function Header() {
  const logoUrl = getStaticUrl("logo.png");

  return (
    <header className="header" id="header">
      <a className="logo" href="/">
        <img src={logoUrl} alt="Logo" loading="eager" />
      </a>

      <nav className="nav-desktop">
        <ul>
          <li>
            <a href="/">Inicio</a>
          </li>
          <li>
            <a
              className="socio"
              href="https://redmaestra.donando.cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Hazte Soci@
            </a>
          </li>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="/"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Otros
            </a>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item"
                  href="https://redmaestra.azurewebsites.net/"
                >
                  Intranet
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/linktree">
                  LinkTree
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <nav className="nav-mobile">
        <ul>
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="/"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Links
            </a>
            <ul className="dropdown-menu">
              <li>
                <a className="dropdown-item" href="/">
                  Inicio
                </a>
              </li>
              <li>
                <a
                  className="nav-socio dropdown-item"
                  href="https://redmaestra.donando.cl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hazte Soci@
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  href="https://redmaestra.azurewebsites.net/"
                >
                  Intranet
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="/linktree">
                  LinkTree
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
